import { useEffect, useRef, useState } from "react";
import { Music, Music2 } from "lucide-react";
import { AMBIENT_AUDIO } from "@/lib/constants";

export default function MusicToggle() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.volume = 0.45;
    a.loop = true;
  }, []);

  const toggle = async () => {
    const a = audioRef.current;
    if (!a) return;
    try {
      if (a.paused) {
        await a.play();
        setPlaying(true);
      } else {
        a.pause();
        setPlaying(false);
      }
    } catch (e) {
      // Autoplay or load issues — silently keep state in sync
      setPlaying(false);
    }
  };

  return (
    <>
      <audio
        ref={audioRef}
        src={AMBIENT_AUDIO}
        preload="auto"
        data-testid="ambient-audio"
      />
      <button
        type="button"
        onClick={toggle}
        data-testid="music-toggle"
        aria-label={playing ? "Pause music" : "Play music"}
        className={`fixed z-50 bottom-6 right-6 md:bottom-8 md:right-8 w-14 h-14 rounded-full flex items-center justify-center border transition-all duration-500 ${
          playing
            ? "bg-burgundy/70 border-gold text-gold heart-tap"
            : "bg-ink-900/70 border-gold/40 text-ivory-muted hover:text-gold hover:border-gold"
        } backdrop-blur-xl shadow-[0_8px_30px_rgba(0,0,0,0.55)]`}
      >
        <span className={`${playing ? "animate-spin-slow" : ""} inline-flex`}>
          {playing ? <Music2 size={20} /> : <Music size={20} />}
        </span>
      </button>
    </>
  );
}
